export default "__VITE_ASSET__VamtCQ____"